import React from 'react';
import { getQuestionLabel } from '@/utils/dynamicForm.util';
import FormCampaignSubscriptionSelect from '@/components/molecules/predictive/FormCampaignSubscriptionSelect';
import { DynamicFormSubscriptionSelectProps } from './types';

/**
 * Dynamic form subscription select field component
 * 
 * Wraps FormCampaignSubscriptionSelect with getQuestionLabel for consistent label handling
 * 
 * @param cfg - Field configuration object
 * @returns JSX element for the subscription select field
 */
const DynamicFormSubscriptionSelect: React.FC<DynamicFormSubscriptionSelectProps> = (cfg) => {
  return <FormCampaignSubscriptionSelect {...cfg} label={getQuestionLabel(cfg)} />;
};

export default DynamicFormSubscriptionSelect;